const PRICES = {
  hostingPlan: { //monthly rates
    't-2': 190,
    't-3': 275,
    't-4': 400,
    't-5': 700,
    't-6': 1050,
    'ca-1': 1500,
    'ca-2': 2700,
    'ca-3': 3000,
    'ca-4': 3700,
    'ca-5': 5000,
    'ca-6': 6000,
    'ca-7': 8000,
    'ca-8': 9000,
    'hz-3': 10000,
  },
  urlType: {purchase: 25},
  integrationDriver: 200,
  dhis2SupportPlan: 0,
  setupFee: {
    't-2': 250,
    't-3': 250,
    't-4': 250,
    't-5': 250,
    't-6': 250,
    'ca-1': 500,
    'ca-2': 500,
    'ca-3': 500,
    'ca-4': 500,
    'ca-5': 500,
    'ca-6': 500,
    'ca-7': 500,
    'ca-8': 500,
    'hz-3': 500,
  }
};

export default PRICES;
